import Certificado from "@/domain/conta/empresa/certificado/Certificado.js";
import Table from "./Table";
export default class TableCertificados extends Table {
    constructor() {
        super();
    }

    getHeaders() {
        var headers;
        headers = [
            { text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false },
            { text: "Nome", value: "nome", show: true, pesq: true, enable: true },
            { text: "Data de Expiração", value: "validade", show: true, pesq: true, enable: true },
            { text: "bvenc", value: "bvenc", show: false, pesq: false, enable: false },
            { text: "_id", value: "_id", show: false, pesq: false, enable: false },
        ]
        return headers
    }

    setNota(arrayNotas, notas) {
        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            newArray.push(
                // password = "", file = "", dtExpiracao
                new Certificado(
                    notas[i].nome,
                    notas[i].validade,
                    notas[i]._id
                )
            );
            this.pagination.sortBy = 'nome';
            this.pagination.descending = false;
            // arrayNotas.sort(function (a, b) {
            //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
            // });

        }
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }
    }
   
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableCertificados.js